import { Carpetta } from './../../../services/ricerca-pratiche.service';
import { Component, OnInit, Inject, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { OrganicoInterrogatorService } from 'src/app/services/organico-interrogator.service';
import { RicercaPraticheService } from 'src/app/services/ricerca-pratiche.service';

@Component({
  selector: 'app-search-carpetta-modal',
  templateUrl: './search-carpetta-modal.component.html',
  styleUrls: ['./search-carpetta-modal.component.scss']
})
export class SearchCarpettaModalComponent implements OnInit {

  public searchCarpettaFormComponent: FormGroup = this.formBuilder.group({
    idPratica: [null],
    numFascicolo: [null],
    numProgrFascicolo: [null],
    oggettoPratica: [null]
  });

  public carpette: FormControl = new FormControl(null, Validators.required);

  public showTable = false;
  public showNoResults = false;
  datasource = [];
  displayedColumns: string[] = ['id pratica', 'numero fascicolo', 'identificativo fascicolo', 'oggetto pratica', ' '];
  public carpLoaded = [];

  ngOnInit() {}

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SearchCarpettaModalComponent>,
    private ricercaPraticheService: RicercaPraticheService,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, isPersonaFisica: boolean, text: string, modalParam: any}) {
  }

  getColumns() {
    return this.displayedColumns;
  }

  loadCarpettaData(index) {
    this.dialogRef.close(this.carpLoaded[index]);
  }

  searchCarpetta() {
    const carpetta: Carpetta = this.searchCarpettaFormComponent.getRawValue();
    this.ricercaPraticheService.findCarpette(carpetta).toPromise().then( response => {
      this.datasource = response.content.map((carp) => {
        return {
          'id pratica' : carp.idPratica,
          'numero fascicolo': carp.numFascicolo,
          'identificativo fascicolo': carp.numProgrFascicolo,
          'oggetto pratica': carp.oggettoPratica,
          ' ': 'loadData'
        };
      });
      this.showTable = this.datasource.length > 0;
      this.showNoResults = this.datasource.length === 0;
      this.carpLoaded = response.content;
    });
  }

}
